import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.handleSystemThemeChange = () => {
      if (!this.storedTheme) {
        this.applyTheme(this.systemTheme)
      }
    }

    this.mediaQuery.addEventListener("change", this.handleSystemThemeChange)
    this.applyTheme(this.currentTheme)
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.handleSystemThemeChange)
  }

  toggle() {
    const theme = this.inputTarget.checked ? "dark" : "light"
    this.storedTheme = theme
    this.applyTheme(theme)
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-bs-theme", theme)
    this.inputTarget.checked = theme === "dark"
  }

  get currentTheme() {
    return this.storedTheme || this.systemTheme
  }

  get storedTheme() {
    try {
      return localStorage.getItem("theme")
    } catch {
      return null
    }
  }

  set storedTheme(theme) {
    try {
      localStorage.setItem("theme", theme)
    } catch {
      // Ignore storage failures; the current page still reflects the toggle.
    }
  }

  get systemTheme() {
    return this.mediaQuery.matches ? "dark" : "light"
  }
}
